import styled from 'styled-components';

export const StyledButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
`;
